export default "__VITE_ASSET__DNQ0Bawy__"